"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._constructInstant = void 0;
var js_temporal_polyfill_1 = require("@mishakanai/js-temporal-polyfill");
var F_PlainDate_1 = __importDefault(require("../PlainDate/F_PlainDate"));
var util_1 = require("../PlainDate/util");
var util_2 = require("../PlainTime/util");
var F_Instant_1 = __importDefault(require("./F_Instant"));
function constructFrom(plain_date, plain_time, timezone) {
    var plainDate = (0, util_1.getPlainDate)(plain_date);
    var plainTime = (0, util_2.getPlainTime)(plain_time);
    var tz = js_temporal_polyfill_1.Temporal.TimeZone.from(timezone !== null && timezone !== void 0 ? timezone : js_temporal_polyfill_1.Temporal.Now.timeZoneId());
    var tf = plainTime.getISOFields();
    var hourStr = ('' + tf.isoHour).padStart(2, '0');
    var minuteStr = ('' + tf.isoMinute).padStart(2, '0');
    var strExceptOffset = "".concat(plainDate.toString(), "T").concat(hourStr, ":").concat(minuteStr);
    return [tz.getInstantFor(strExceptOffset), tz];
}
function _constructInstant(arg1, arg2, arg3) {
    if (typeof arg2 !== 'undefined' && typeof arg3 !== 'undefined') {
        if (typeof arg1 === 'object') {
            // add option to chain if invalid.
            throw new Error('invalid usage.');
        }
        var _a = constructFrom(arg1, arg2, arg3), instant = _a[0], tz = _a[1];
        return [new F_Instant_1.default(instant), tz];
    }
    if (typeof arg1 === 'string') {
        var instant = js_temporal_polyfill_1.Temporal.Instant.from(arg1);
        return [new F_Instant_1.default(instant), js_temporal_polyfill_1.Temporal.TimeZone.from(js_temporal_polyfill_1.Temporal.Now.timeZoneId())];
    }
    if (arg1 && typeof arg1 === 'object') {
        if (arg1 instanceof F_PlainDate_1.default) {
            throw new Error('invalid usage');
        }
        var _b = constructFrom(arg1.date, arg1.time, arg1.timezone), instant = _b[0], tz = _b[1];
        return [new F_Instant_1.default(instant), tz];
    }
    return null;
}
exports._constructInstant = _constructInstant;
//# sourceMappingURL=util.js.map